import React from 'react';
import PasswordResetPage from '../core/auth/PasswordResetPage';
import { API } from '../backend';

const brand = {
    eyebrow: 'Account recovery',
    title: 'Locked out? Back on the road in a minute.',
    text: "We'll email a 6-digit code to the address on your driver file, then you pick a new password.",
};

export default function DriverPasswordReset() {
    return (
        <PasswordResetPage
            bannerRole="driver"
            brand={brand}
            apiBase={`${API}/driver/password/reset`}
            idKey="driverId"
            signinPath="/driverSignin"
            help={<>No email on file? Ask dispatch to reset your password, or email <a href="mailto:admin@tripletrans.ca">admin@tripletrans.ca</a>.</>}
        />
    );
}
